<template>
    <div class="account-coin">
        <img src="./images/coin.png" alt="余额" class="coin-icon">
        {{ coin }}
    </div>
</template>

<script>
import AccountModel from "@/models/account"

const account = new AccountModel()

export default {
    name: 'AccountCoin',
    data() {
        return {
            coin: 0,
        }
    },
    methods: {
        getCoin() {
            account.coin().then(res => {
                this.coin = res.data.real
            })
        },
    },
    created() {
        this.getCoin()
    }
}
</script>

<style scoped>
.account-coin {
    position: relative;
    display: flex;
    align-items: center;
    padding: 12px 28px 12px 66px;
    background: #fff3d3;
    border-radius: 48px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
    font-size: 28px;
    font-weight: bold;
    color: #B18F54;
    line-height: 1;
}
.coin-icon {
    position: absolute;
    left: 2px;
    width: 58px;
    height: 58px;
}
</style>